import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { PageName } from '../../shared/types';
import DatePicker from '@grnhse/seedling/lib/birch/components/forms/date_picker';
import DividerLabel from '../divider_label';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import styled from 'styled-components';
import { parseDate, formatDate } from '../../lib/utils';

type Props = {
  pageName: PageName;
};

const Wrapper = styled(Stack)`
  > div:first-child,
  > div:last-child {
    display: flex;
    flex-grow: 1;

    > div:first-child {
      display: flex;
      flex-grow: 1;

      > div:first-child {
        display: flex;
        flex-grow: 1;
      }

      .react-datepicker {
        min-width: 310px;
      }
    }
  }
`;

const LastActivity = ({ pageName }: Props) => {
  const { watch, setValue } = useFormContext();
  const [userDateFormat, start, end] = watch([
    'user_date_format',
    'last_activity_start',
    'last_activity_end',
  ]);

  const startDate = parseDate(start, userDateFormat);
  const endDate = parseDate(end, userDateFormat);

  const onDateChange = (
    newDate: Date | null,
    value: 'last_activity_start' | 'last_activity_end'
  ) => {
    setValue(value, formatDate(newDate, userDateFormat), {
      shouldDirty: true,
    });
  };

  const t = withLocalePrefix(`talent_${pageName}.labels`);

  return (
    <Wrapper
      direction="row"
      justifyContent="space-between"
      spacing={2}
      alignItems="center"
      divider={<DividerLabel>{t('date_picker_separator')}</DividerLabel>}
    >
      <DatePicker
        label={t('last_activity_start')}
        onChange={(date) => onDateChange(date, 'last_activity_start')}
        selected={startDate}
        dateFormat={userDateFormat}
      />
      <DatePicker
        label={t('last_activity_end')}
        onChange={(date) => onDateChange(date, 'last_activity_end')}
        selected={endDate}
        dateFormat={userDateFormat}
      />
    </Wrapper>
  );
};

export default LastActivity;
